<script>
/**
 * drop down with items
 */
export default {
  props: {
    textToggle: {
      type: String,
      default: '',
      require: true,
    },
    textHeader: {
      type: String,
      default: '',
      require: false,
    },
    countNotification: {
      type: [Number, String],
      default: 0,
      require: false,
    },
    items: {
      type: Array,
      default: () => [
        {
          label: '',
          to: '',
        },
      ],
      require: true,
    },
  },
  data() {
    return {
      itemsCount: 42,
    }
  },
  computed: {
    isCoreIcon(item) {
      return item.icon && item.iconType === 'core-icon'
    },
    isFontAweSomeIcon(item) {
      return item.icon && item.iconType === 'font-awesome'
    },
  },
}
</script>

<template>
  <CDropdown
    id="base-nav-drop-down"
    in-nav
    class="c-header-nav-items"
    placement="bottom-end"
    add-menu-classes="pt-0"
    caret
  >
    <template v-slot:toggler>
      <CHeaderNavLink>
        <slot name="prepend-icon">
          <font-awesome-icon icon="user-circle" />
        </slot>
        <span class="mx-1">
          {{ textToggle }}
        </span>
        <CBadge
          v-if="!!countNotification"
          color="danger"
          class="position-relative mt-0 nav-dropdown-badge mr-1"
          >{{ countNotification }}</CBadge
        >
        <font-awesome-icon icon="caret-down" />
      </CHeaderNavLink>
    </template>

    <CDropdownHeader
      v-if="!!textHeader"
      tag="div"
      class="text-left"
      color="light"
    >
      <strong>{{ textHeader }}</strong>
    </CDropdownHeader>
    <CDropdownDivider class="m-0" />
    <div class="notification-list">
      <div v-for="(item, index) in items" :key="index">
        <slot name="prepend-item" :item="item">
          <CDropdownItem :to="item.to">
            {{ item.label }}
          </CDropdownItem>
        </slot>
        <CDropdownDivider class="m-0" />
      </div>
    </div>
  </CDropdown>
</template>

<style lang="scss" scoped>
#base-nav-drop-down ::v-deep .nav-dropdown-badge {
  left: 0%;
}
#base-nav-drop-down ::v-deep .dropdown-menu {
  padding: 0 !important;
}
</style>
